// extracted by mini-css-extract-plugin
export var copyableField = "_qf-4";
export var customerBadge = "_qf-0";
export var customerInfoTitle = "_qf-2";
export var details = "_qf-1";
export var dropdownContainer = "_qf-5";
export var dropdownImage = "_qf-6";
export var editAssigneeForm = "_qf-a";
export var editButton = "_qf-3";
export var email = "_qf-7";
export var hidden = "_qf-d";
export var input = "_qf-8";
export var saveButton = "_qf-b";
export var shopifyIcon = "_qf-c";
export var suggestionBadge = "_qf-e";
export var suggestionText = "_qf-f";
export var username = "_qf-9";